export const lifecycleStates = {
  ordered: 'info',
  shipped: 'secondary',
  activated: 'success',
  disabled: 'dark',
  waiting: 'danger',
  'activated-legacy': 'success',
};
